/**
 * Unguarded auth pages (login + password flows). An already-authenticated
 * user should never sit on one of these: the auth guard bounces them off, and
 * initApp() redirects off them (and fires the login tracking event) once the
 * profile loads.
 *
 * Keep in sync with the route names in routes.ts (authRoutes).
 */
export const AUTH_PAGE_NAMES: readonly string[] = [
  'login',
  'changePwd',
  'forceChangePwd',
  'forgotPwd'
];
